require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./about-our-learning-environments.json") })
        }
      }, "path---about-our-learning-environments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---about-our-learning-environments!./.cache/json/about-our-learning-environments.json
// module id = 1220
// module chunks = 231608221292675